import CollectionHeadline from './CollectionHeadline';

export default CollectionHeadline;
